import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=dc2d9cee"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=dc2d9cee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports